import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebrtcComponent } from './simple-icons-webrtc.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebrtcComponent ],
    exports:      [ SimpleIconsWebrtcComponent ],
    bootstrap:    []
})
export class SimpleIconsWebrtcModule {}
